import { Flex } from "@dna/react";
import { Button, FormControl, IconButton, InputAdornment, makeStyles, TextField } from "@material-ui/core";
import { useState } from "react";
import { useHistory } from "react-router-dom";
import { clinicalAuthService } from "../../services/medicationmanagement/clinicalAuth/ClinicalAuthApi";
import { useIdentity } from "../auth/useIdentity";
import { FlatButton } from "../common/FlatButton";
import { FormControlContainer } from "../register-user/FormControlContainer";
import styles from "./Relogin.module.scss";
import { ReactComponent as Visibility } from "../../images/visibility-fill.svg";
import { ReactComponent as VisibilityOff } from "../../images/visibilityOff-fill.svg";
import React from "react";

export const Relogin = () => {
    let { loading, identity, error } = useIdentity();
    const [password, setPassword] = useState('');
    const [errorMessage, setErrorMessage] = useState('');
    let history = useHistory();
    const [showPassword, setShowPassword] = useState(false);
    const handleClickShowPassword = () => setShowPassword(!showPassword);

    let payloadKey = localStorage.getItem('reloginPayloadKey');
    const onSubmit = () => {

        let url = window.location.search;
        let params = new URLSearchParams(url);
        let redirctUri = params.get('redirct_uri');
        //redirct url contains path parameters which we can't read with parameter name. 
        //So, need to split the pathname and read from it using index.
        //Sample url https://{domain}/residents/gp/{authoringSystem}/{authoringSystemForeignKey}/{optinal medication id}
        let redirctUrl = new URL(redirctUri ? redirctUri : '');
        let authoringSystem = redirctUrl.pathname.split('/')[3];
        let authoringSystemForeignKey = redirctUrl.pathname.split('/')[4];

        //If there's a medication id in redirect url and it redircts back to medications with this medication id 
        //then new medication is not adding as it's consediring the current medication medication as draft medication.
        //So, need to remove the medication id if exists.
        if (redirctUrl.pathname.split('/')[5]) {
            redirctUri = redirctUri ? redirctUri.substring(0, redirctUri.lastIndexOf("/")) : '';
        }
        
        let userCreds = btoa(`${identity?.externalUserName}:${password}`);
        clinicalAuthService.validateClinicalUser(authoringSystem, authoringSystemForeignKey, userCreds).then((res) => {
            window.location.href = redirctUri ? redirctUri + `?payloadKey=${payloadKey}` : '';
        }).catch((err) => {
            setErrorMessage('Invalid password');
        });        
    };

    return (

        <div className={styles.background}>
            <div className={styles.inner}>
                <FormControl>
                    <Flex
                        css={{
                            gap: "small",
                            padding: "small",
                        }}
                    >
                        <div className={styles.content}>
                            <div
                            >
                                <div className={styles.header}>
                                    Re-authenticate for controlled medication
                                </div>
                                <div className={styles.body}>
                                    <p>
                                        To prescribe a controlled medication you need to enter  your Clinical Manager password for <label style={{ fontWeight: 600 }}>{identity?.externalUserName}</label>:
                                    </p>
                                </div>
                            </div>
                            <TextField
                                type={showPassword ? "text" : "password"}
                                label="Password"
                                required
                                helperText={errorMessage ? errorMessage : ''}
                                placeholder=""
                                fullWidth
                                margin="normal"
                                onFocus={() => { setErrorMessage('') }}
                                onChange={(event) => { setPassword(event.target.value) }}
                                InputLabelProps={{
                                    shrink: true,                                
                                    classes: {
                                        root: errorMessage ? styles.textFieldlabelError : styles.textFieldlabel,
                                        focused: styles.textFieldlabel,
                                        asterisk: styles.textFieldlabelError
                                    }
                                }}
                                InputProps={{
                                    classes: {
                                        root: errorMessage ? styles.textFieldError : styles.textField,
                                        focused: styles.textField
                                    },
                                    endAdornment: (
                                        <InputAdornment position="end">                                     
                                            <IconButton aria-label="show/hide password" onClick={handleClickShowPassword} className={styles.visibilityButton}>
                                                {showPassword ? <VisibilityOff /> : <Visibility/>}
                                            </IconButton>
                                        </InputAdornment>
                                    )
                                }}
                                FormHelperTextProps={{
                                    classes: {
                                        root: styles.helperTextError
                                    }
                                }}
                            />

                        </div>
                        <hr className={styles.divider} />
                        <div className={styles.footer}>
                            <Button onClick={() => history.goBack()}                                
                            className={styles.cancelButton}>
                                Cancel
                            </Button>
                            &nbsp;&nbsp;&nbsp;
                            <FlatButton
                                type="button"
                                kind="primary"
                                isDisabled={password.length <= 0}
                                css={{
                                    width: 104,
                                    alignSelf: "flex-end",
                                }}
                                onPress={(e) => onSubmit()}
                            >
                                OK
                            </FlatButton>
                        </div>
                    </Flex>
                </FormControl>
            </div>
        </div>
    );
};
